import {createFileRoute, Outlet, redirect, useLocation} from '@tanstack/react-router';
import {DOCUMENT_LIST} from '@/patient/routing/paths';
import DocumentList from '@/patient/views/document/DocumentList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

function DocumentListLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === DOCUMENT_LIST;
  return isRoot ? <DocumentList /> : <Outlet />;
}

export const Route = createFileRoute('/(patient)/documents')({
  component: DocumentListLayout,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
